import iconInfo from "../../../assets/img/parents/iconInfo.svg";
import iconCalendar from "../../../assets/img/parents/iconCalendar.svg";
import iconTextbook from "../../../assets/img/parents/iconTextbook.svg";
import iconFriends from "../../../assets/img/parents/iconFriends.svg";
import iconCourses from "../../../assets/img/parents/iconCourses.svg";
import iconAbsences from "../../../assets/img/parents/iconAbsences.svg";
import iconInfoActive from "../../../assets/img/parents/iconInfoActive.svg";
import iconCalendarActive from "../../../assets/img/parents/iconCalendarActive.svg";
import iconTextbookActive from "../../../assets/img/parents/iconTextbookActive.svg";
import iconFriendsActive from "../../../assets/img/parents/iconFriendsActive.svg";
import iconCoursesActive from "../../../assets/img/parents/iconCoursesActive.svg";
import iconAbsencesActive from "../../../assets/img/parents/iconAbsencesActive.svg";
import iconBack from "../../../assets/img/iconBack.svg";
import avatar from "../../../assets/img/col9.jpg";
import redCircle from "../../../assets/img/parents/red-circle.svg";
import redPlus from "../../../assets/img/parents/red_plus.svg";
import wavyLineGreen from "../../../assets/img/parents/wavy_line_green.svg";
import doubleTriangleYellow from "../../../assets/img/parents/double_triangle_yellow.svg";
import grayCircle from "../../../assets/img/parents/gray_circle_with_lines.svg";
import iconEvaluation from "../../../assets/img/iconEvaluation.svg";
import iconEvaluationActive from "../../../assets/img/iconEvaluationActive.svg";

export const images = {
  iconInfo,
  iconCalendar,
  iconTextbook,
  iconFriends,
  iconCourses,
  iconAbsences,
  iconInfoActive,
  iconCalendarActive,
  iconTextbookActive,
  iconFriendsActive,
  iconCoursesActive,
  iconAbsencesActive,
  iconBack,
  avatar,
  redCircle,
  redPlus,
  wavyLineGreen,
  doubleTriangleYellow,
  grayCircle,
  iconEvaluation,
  iconEvaluationActive
};
